import _ from 'lodash';
import Loadable from 'react-loadable';
import { Loading } from '@HOC';
import { bundleComponent } from './Bundles';

const createComponents = (config, pageDirName) => {
  return _.map(_.get(config, 'router'), item => {
    // 为了兼容之前的结构 处理有详情的页面
    let url = `${pageDirName}`;
    if (item.isDetail) {
      // 针对有详情的页面的单独处理
      url = `${pageDirName}/components/${item.pathDir}`;
    }

    // 创建组件
    const component = Loadable({
      loader: () => import(`../page/${url}`),
      loading: Loading,
      render: bundleComponent(_.get(config, 'title')),
    });

    return {
      ...item,
      path: item.path,
      cacheKey: item.path,
      component,
    };
  });
};

const pages = require.context('../page/', true, /page.config.(t|j)s$/);
const routers = _.reduce(
  pages.keys(),
  (prev, item) => {
    const pageDirName = item.replace(/^\.\/(\w*)\/(.*)\.\w+$/, '$1');
    const mod = pages(item);
    const config = mod.default ? mod.default : mod;

    return [...prev, ...createComponents(config, pageDirName)];
  },
  [],
);

export default [...routers, { isRedirect: true, to: '/404' }];
